import purchase from './purchase'
import management from './management'
export default {
  purchase,
  management
}



// WEBPACK FOOTER //
// ./src/api/apis/self/inputInvoice/index.js